export interface WarstwyDodatkoweState {
  widocznosci: Record<string, boolean>;
}

export const initialWarstwyDodatkoweState: WarstwyDodatkoweState = {
  widocznosci: {}
};
